/* eslint-disable react/prop-types */
import React, {useState} from 'react';
import {getThumbnailImage} from '../../../HelperClasses/SingletonClass';
import {CONFIG_CONSTANT} from '../../../Constants/ConfigsConstants';
import {onDeleteCart} from '../Actions/OnDeleteCart';
import ToastPopup from '../../../HelperClasses/AppLoaderClasses/ToastPopup';
import {onUpdateCart} from '../Actions/OnUpdateCart';

const CartItemBox = ({
  fullCartInfo,
  setFullCartInfo,
  pk_key,
  setIsLoading,
  selectedUser,
}) => {
  const {cart, cart_details} = fullCartInfo;
  const checkoutType = cart_details[0]?.listing?.order_type;

  const updateCartQuantity = async (listing, quantity, increase) => {
    let cartData;
    if (increase) {
      if (quantity < listing.max_quantity) {
        if (
          (quantity === listing.stock || quantity > listing.stock) &&
          CONFIG_CONSTANT?.LISTINGS_CONFIGS?.enable_stock
        ) {
          ToastPopup({
            message: 'Stock is not available',
            type: 'error',
          });
          return false;
        } else {
          cartData = {
            cart: {
              listing_id: listing.id,
              quantity: quantity + 1,
            },
          };
        }
      } else {
        ToastPopup({
          message: `Max quantity is ${listing.max_quantity}`,
          type: 'error',
        });
        return false;
      }
    } else {
      if (quantity > 1) {
        cartData = {
          cart: {
            listing_id: listing.id,
            quantity: quantity - 1,
          },
        };
      } else {
        delete_cart(listing.id);
        return false;
      }
    }

    await onUpdateCart({
      setFullCartInfo,
      setIsLoading,
      selectedUser,
      pk_key,
      cartData,
    });
  };

  const delete_cart = id => {
    onDeleteCart({
      setFullCartInfo,
      setIsLoading,
      selectedUser,
      pk_key,
      listing_id: id,
    });
  };

  //

  return (
    <div className="flex flex-col gap-4 bg-white shadow-c-sm rounded-card p-4">
      <h1 className="text-lg font-bold">Items in the cart</h1>
      {cart_details.map(cartItem => {
        return cartItem.variant ? (
          <div
            className=" w-full border border-primary rounded-card   flex items-center   relative"
            key={cartItem.id}>
            <div className=" flex-none h-full  relative   ltr:mr-3 rtl:ml-3 ">
              {(cartItem.listing?.images?.length > 0 ||
                cartItem?.variant.images?.length > 0) && (
                <img
                  src={
                    cartItem?.variant.images?.length > 0
                      ? cartItem?.variant.images[0]
                      : getThumbnailImage(cartItem.listing.images[0])
                  }
                  className="w-[100px] h-[100px]  rounded-image  object-cover"
                  alt="Order Items"
                />
              )}
            </div>
            <div className="flex-grow flex flex-col xs:flex-row xs:items-center justify-start flex-wrap sm:flex-nowrap gap-2">
              <div className="flex-grow">
                {CONFIG_CONSTANT?.LISTINGS_CONFIGS?.enable_stock && (
                  <p className=" text-xs  font-semibold leading-6 text-primary">
                    {`${cartItem?.variant.stock} Products in Stock`}
                  </p>
                )}

                <div className="flex flex-wrap items-center justify-start gap-2">
                  {cartItem?.variant?.variant_values?.map(
                    (vr_value, index, array) => {
                      return (
                        <p
                          key={vr_value.variant_type.id}
                          className=" mt-[8px] text-default_gray text-xs font-medium flex flex-wrap items-center">
                          {vr_value.variant_type.name}:{' '}
                          {vr_value.variant_type_value.name}
                          {index !== array?.length - 1 && ','}
                        </p>
                      );
                    },
                  )}
                </div>

                {cartItem?.listing?.account?.name && (
                  <p className=" mt-[8px] text-default_gray text-xs font-medium flex flex-wrap items-center">
                    by {cartItem.listing?.account?.name}
                  </p>
                )}
                <p className=" mt-[11px] text-primary text-xs font-bold flex flex-wrap items-center    ">
                  {cartItem?.variant?.offer_price.formatted}
                </p>
              </div>
              <div className="  flex-none   flex   items-center  gap-3">
                <div className="  min-w-[90px] h-[32px] border border-primary rounded-button  flex justify-between items-center ">
                  <button
                    onClick={() =>
                      updateCartQuantity(
                        cartItem.listing,
                        cartItem.quantity,
                        false,
                      )
                    }
                    className=" w-[32px] h-[32px] bg-primary  ltr:rounded-l-button rtl:rounded-r-button flex justify-center items-center text-xl leading-6 font-medium text-white">
                    -
                  </button>
                  <span className=" text-sm leading-4 font-medium text-[#4A4A4A] mx-3">
                    {cartItem.quantity}
                  </span>
                  <button
                    onClick={() =>
                      updateCartQuantity(
                        cartItem.listing,
                        cartItem.quantity,
                        true,
                      )
                    }
                    className="w-[32px] h-[32px] bg-primary  ltr:rounded-r-button rtl:rounded-l-button flex justify-center items-center text-xl leading-6 font-medium  text-white ">
                    +
                  </button>
                </div>
                <div className=" ">
                  <button
                    className="w-[32px] h-[32px] bg-primary   flex justify-center items-center text-xl leading-6 font-medium  text-white  rounded"
                    onClick={() => delete_cart(cartItem.listing.id)}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            className=" w-full border border-primary rounded-card   p-4  flex items-center    relative"
            key={cartItem.id}>
            <div className=" flex-none h-full  relative   ltr:mr-3 rtl:ml-3 ">
              {cartItem.listing?.images?.length > 0 && (
                <img
                  src={getThumbnailImage(cartItem.listing.images[0])}
                  className="w-[100px] h-[100px]  rounded-image  object-cover"
                  alt="Order Items"
                  onError={e => {
                    e.target.src = cartItem.listing.images[0];
                  }}
                />
              )}
            </div>
            <div className="flex-grow flex flex-col xs:flex-row xs:items-center justify-start flex-wrap sm:flex-nowrap gap-2">
              <div className="flex-grow">
                {CONFIG_CONSTANT?.LISTINGS_CONFIGS?.enable_stock &&
                  checkoutType !== 'events' &&
                  checkoutType !== 'appointments' &&
                  checkoutType !== 'digital' && (
                    <p className=" text-xs  font-semibold leading-6 text-primary">
                      {`${cartItem.listing.stock} Products in Stock`}
                    </p>
                  )}
                <p className=" text-base text-black font-semibold mt-[2px]">
                  {cartItem.listing.title}
                </p>
                {cartItem?.listing?.account?.name && (
                  <p className=" text-default_gray text-xs font-medium flex flex-wrap items-center">
                    by {cartItem.listing?.account?.name}
                  </p>
                )}
                <p className=" mt-[11px] text-primary   font-medium flex flex-wrap items-center text-sm ">
                  {cartItem.listing.offer_price.formatted}
                </p>
                {/* tax */}
                <div className=" mt-0 flex flex-col gap-2">
                  {cartItem?.listing?.listing_taxes?.map(it => {
                    return (
                      <p className="  text-primary   font-medium flex flex-wrap items-center text-sm ">
                        +{it.amount.formatted} ({it.note})
                      </p>
                    );
                  })}
                </div>
              </div>
              <div className="  flex-none   flex   items-center  gap-3">
                {checkoutType !== 'events' &&
                  checkoutType !== 'appointments' &&
                  checkoutType !== 'digital' && (
                    <div className="  min-w-[90px] h-[32px] border border-primary rounded-button  flex justify-between items-center ">
                      <button
                        onClick={() =>
                          updateCartQuantity(
                            cartItem.listing,
                            cartItem.quantity,
                            false,
                          )
                        }
                        className=" w-[32px] h-[32px] bg-primary  ltr:rounded-l-button rtl:rounded-r-button flex justify-center items-center text-xl leading-6 font-medium text-white">
                        -
                      </button>
                      <span className=" text-sm leading-4 font-medium text-[#4A4A4A] mx-3">
                        {cartItem.quantity}
                      </span>
                      <button
                        onClick={() =>
                          updateCartQuantity(
                            cartItem.listing,
                            cartItem.quantity,
                            true,
                          )
                        }
                        className="w-[32px] h-[32px] bg-primary  ltr:rounded-r-button rtl:rounded-l-button flex justify-center items-center text-xl leading-6 font-medium  text-white ">
                        +
                      </button>
                    </div>
                  )}
                <div className=" ">
                  <button
                    className="w-[32px] h-[32px] bg-primary   flex justify-center items-center text-xl leading-6 font-medium  text-white  rounded"
                    onClick={() => delete_cart(cartItem.listing.id)}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CartItemBox;
